import Vue from 'vue';

export interface MeetingErrorConfig {
  titleKey: string;
  variant: 'danger' | 'warning' | 'info';
  primaryBtnTextKey?: string;
}

export const meetingErrorMapping: Record<string, MeetingErrorConfig> = {
  // 1. Quota & Limits
  ParticipantPoolExceeded: {
    titleKey: "limitExceededTitle",
    variant: "danger",
    primaryBtnTextKey: "close",
  },
  StartMeetingExceed: {
    titleKey: "limitExceededTitle",
    variant: "danger",
    primaryBtnTextKey: "close",
  },
  MeetingCountDailyIsExceeded: {
    titleKey: "limitExceededTitle",
    variant: "danger",
    primaryBtnTextKey: "close",
  },
  NumberOfParticipantIsExceeded: {
    titleKey: "limitExceededTitle",
    variant: "danger",
    primaryBtnTextKey: "close",
  },
  AiQuotaExceeded: {
    titleKey: "limitExceededTitle",
    variant: "warning",
    primaryBtnTextKey: "close",
  },
  RecordingStorageExceeded: {
    titleKey: "limitExceededTitle",
    variant: "warning",
    primaryBtnTextKey: "close",
  },

  CustomerSubscriptionIsExpired: {
    titleKey: "customerSubscriptionIsExpiredTitle",
    variant: "danger",
    primaryBtnTextKey: "close",
  },
  CustomerSubscriptionNotFound: {
    titleKey: "customerSubscriptionNotFoundTitle",
    variant: "danger",
    primaryBtnTextKey: "close",
  },
  NotFoundPlanInCustomerSubscription: {
    titleKey: "notFoundPlanInCustomerSubscriptionTitle",
    variant: "danger",
    primaryBtnTextKey: "close",
  },

  // 2. Authentication & Authorization
  TokenInvalid: {
    titleKey: "tokenInvalidTitle",
    variant: "danger",
  },
  TokenOriginalExpired: {
    titleKey: "tokenInvalidTitle",
    variant: "danger",
  },
  Forbidden: {
    titleKey: "forbiddenTitle",
    variant: "danger",
  },
  IpBanned: {
    titleKey: "forbiddenTitle",
    variant: "danger",
  },
  UserNotAuthenticated: {
    titleKey: "tokenInvalidTitle",
    variant: "danger",
  },
  AccessDenied: {
    titleKey: "forbiddenTitle",
    variant: "danger",
  },
  InternalServerError: {
    titleKey: "internalServerErrorTitle",
    variant: "danger",
    primaryBtnTextKey: "close",
  },

  // 3. Meeting State & Not Found
  MeetingNotFound: {
    titleKey: "meetingNotFoundTitle",
    variant: "danger",
  },
  MeetingStatusNotPendingOrEnd: {
    titleKey: "meetingStatusNotPendingOrEndTitle",
    variant: "danger",
  },
  LockTimeout: {
    titleKey: "lockTimeoutTitle",
    variant: "danger",
  },

  // 4. Config & Whiteboard
  NoActiveApiConfigForPlan: {
    titleKey: "forbiddenTitle",
    variant: "danger",
  },
  WhiteboardInUseByOtherMeeting: {
    titleKey: "whiteboardInUseByOtherMeetingTitle",
    variant: "danger",
  },
  CreateMeetingCoreFailed: {
    titleKey: "createMeetingCoreFailedTitle",
    variant: "danger",
  },
  InvalidInternalMeetingId: {
    titleKey: "createMeetingCoreFailedTitle",
    variant: "danger",
  },

  MaxParticipantPoolIsRequired: {
    titleKey: "createMeetingCoreFailedTitle",
    variant: "danger",
    primaryBtnTextKey: "close",
  }
};

export function getMeetingErrorConfig(code: string, vueInstance: Vue) {
  const config = meetingErrorMapping[code] || {
    titleKey: "alert",
    variant: "danger",
  };

  const title = vueInstance.$te(config.titleKey)
    ? vueInstance.$t(config.titleKey).toString()
    : vueInstance.$t("alert").toString();

  const primaryBtnText = config.primaryBtnTextKey && vueInstance.$te(config.primaryBtnTextKey)
    ? vueInstance.$t(config.primaryBtnTextKey).toString()
    : vueInstance.$t("close").toString();

  return {
    title,
    variant: config.variant,
    primaryBtnText,
  };
}
